import styled from "styled-components";

export const UserStyled = styled.main`
  .content-inner {
    padding: 30px;
  }
  .profile__row {
    align-items: center;
  }
  .info-profile {
    margin: auto 0;
  }
  .history-profile {
    margin-top: 40px;
  }
`
